export default {
  image () {
    const self = this
    if (self.image instanceof File) {
      const reader = new FileReader()

      reader.readAsDataURL(self.image)

      reader.onload = function () {
        self.setting.value = reader.result
      }
    }
  },
}
